import React, {Component} from 'react'
import propTypes from 'prop-types'
import {prefix} from 'helpers/component'
import {getPartType} from 'helpers/parts'
import Icon from 'components/icon'
import FileSelect from 'components/fileSelect'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import iconNames from 'theme/icons'
import {get, isEmpty, isNil} from 'lodash'
import './partImage.scss'
import {OrderItemType} from 'helpers/orders'
import FileUploader from 'components/fileUploader'

class PartImage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      imageLoaded: false,
      menuOpen: false,
      menuAnchor: null,
    }

    this.getClass = prefix('partImage-')
  }

  componentDidUpdate(prevProps) {
    const {lastUpdated} = this.props
    if (lastUpdated !== prevProps.lastUpdated)
      this.setState({imageLoaded: false})
  }

  imageLoaded = () => {
    this.setState({imageLoaded: true})
  }

  onShowMenu = (e) => {
    const {allowChange} = this.props
    if (allowChange) {
      this.setState({
        menuOpen: true,
        menuAnchor: e.currentTarget,
      })
    }
  }

  onHideMenu = () => {
    this.setState({menuOpen: false})
  }

  fileSelected = (file) => {
    this.onHideMenu()
    this.props.onUpload(file)
  }

  onRemoveImage = () => {
    this.onHideMenu()
    this.props.onRemove()
  }

  getIconName = (part) => {
    const entityType = get(part, 'type.id', null)
    switch (entityType) {
      case OrderItemType.entered:
        return iconNames.material
      case OrderItemType.builder:
        return iconNames.priceBuilder
      case OrderItemType.pricing_template:
        return iconNames.pricingTemplate
      case OrderItemType.calc_wizard:
        return iconNames.calcWizard
      default:
        const partType = getPartType(part.type) || getPartType(part.partType)
        return partType
            ? partType.icon
            : undefined
    }
  }

  getSourceUrl = (partImages, lastUpdated) => {
    const partImage = partImages[0]
    const url = get(partImage, 'url', null)
    return `${url}?ms=${lastUpdated}`
  }

  getIcon = (imageLoaded, part, size, iconColour) => {
    return imageLoaded
        ? null
        : <Icon
            className={this.getClass('icon')}
            name={this.getIconName(part)}
            size={size}
            color={iconColour}
            onClick={this.onShowMenu}/>
  }

  getEditIcon = (allowChange, muiTheme) => {
    return allowChange
        ? (
            <div className={this.getClass('overlay')}>
              <Icon
                  className={'edit-part-image'}
                  name={iconNames.edit}
                  size={24}
                  color={muiTheme.palette.primaryIconColor}/>
            </div>
        )
        : null
  }

  getImage = (part, size, lastUpdated) => {
    const partImages = get(part, 'partImages', [])
    return isEmpty(partImages)
        ? null
        : (
            <img
                className={this.getClass('image')}
                src={this.getSourceUrl(partImages, lastUpdated)}
                style={{
                  maxWidth: size,
                  maxHeight: size,
                }}
                alt={`${part.partCode} - ${part.description}`}
                onLoad={this.imageLoaded}
            />
        )
  }

  getClassNames = (imageLoaded, allowChange, menuOpen) => {
    const classNames = ['container']

    if (imageLoaded)
      classNames.push('withImage')

    if (allowChange) {
      classNames.push('editable')
    }

    if (menuOpen)
      classNames.push('menuOpen')

    return classNames
  }

  getMenuOptions = (muiTheme, imageLoaded) => {
    const changeLabel = 'Change your part image'
    const removeLabel = 'Remove your part image'
    const addLabel = 'Add your part image'
    return imageLoaded
        ? [
          <FileSelect key="upload" onSelect={this.fileSelected}>
            <MenuItem
              key={'upload-part-image'}
              className={'upload-part-image'}
            >
              <ListItemIcon><Icon name={iconNames.upload}/></ListItemIcon>
              {changeLabel}
            </MenuItem>
          </FileSelect>,
          <MenuItem
            key={'remove-part-image'}
            className={'remove-part-image'}
            onClick={this.onRemoveImage}
            style={{color: muiTheme.palette.errorColor}}
          >
            <ListItemIcon><Icon name={iconNames.delete} color={muiTheme.palette.errorColor}/></ListItemIcon>
            {removeLabel}
          </MenuItem>,
        ]
        : [
          <FileSelect key="upload" onSelect={this.fileSelected}>
            <MenuItem
              key={'upload-part-image'}
              className={'upload-part-image'}
            >
              <ListItemIcon><Icon name={iconNames.upload}/></ListItemIcon>
              {addLabel}
            </MenuItem>
          </FileSelect>,
        ]
  }

  render() {
    const {muiTheme} = this.context
    const {part, size, iconColour, allowChange, lastUpdated} = this.props
    const {imageLoaded, menuOpen, menuAnchor} = this.state
    const classes = this.getClassNames(imageLoaded, allowChange, menuOpen)
    return (
        <React.Fragment>
          <FileUploader
              onFileUpload={this.fileSelected}
              dropLabel="Drop a logo here to add it to this company"
              showPlaceholder={false}>
            {isNil(part)
                ? null
                : (

                    <div className={this.getClass(classes)} style={{width: size, height: size, padding: '12px'}}
                         onClick={this.onShowMenu}>
                      {this.getImage(part, size, lastUpdated)}
                      {this.getIcon(imageLoaded, part, size, iconColour)}
                      {this.getEditIcon(allowChange, muiTheme)}
                      <Menu
                        classes={{paper: 'part-image-popover'}}
                        getContentAnchorEl={null}
                        onClick={(e) => e.stopPropagation()}
                        open={menuOpen}
                        anchorEl={menuAnchor}
                        anchorOrigin={{horizontal: 'left', vertical: 'top'}}
                        transformOrigin={{horizontal: 'left', vertical: 'top'}}
                        onClose={this.onHideMenu}
                        MenuListProps={{className: 'part-image-popover'}}
                        disableRestoreFocus={true}>
                          {this.getMenuOptions(muiTheme, imageLoaded)}
                        </Menu>
                    </div>
                )
            }
          </FileUploader>
        </React.Fragment>
    )
  }

}

PartImage.propTypes = {
  part: propTypes.object.isRequired,
  size: propTypes.number,
  iconColour: propTypes.string,
  allowChange: propTypes.bool,
  lastUpdated: propTypes.number,
  onUpload: propTypes.func.isRequired,
  onRemove: propTypes.func.isRequired,
}

PartImage.defaultProps = {
  iconColor: null,
  allowChange: false,
  size: 20,
}

PartImage.contextTypes = {
  muiTheme: propTypes.object.isRequired,
}

export default PartImage
